module.exports = __webpack_public_path__ + "img/user-14.12696780.svg";